import { jsxs as o, jsx as l } from "react/jsx-runtime";
const e = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M52.584 45.876h-7.638l2.268-2.351-2.224-.601-3.914 3.952 3.911 3.95 2.227-.597-2.27-2.353h7.109l.53-1.998.001-.002ZM26.374 28.33l-5.789 1.551 1.551 5.789 5.789-1.551-1.551-5.789Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M46.83 35.76c-6.138 0-11.114 4.976-11.114 11.114 0 6.138 4.976 11.114 11.114 11.114 6.138 0 11.114-4.976 11.114-11.114 0-6.138-4.975-11.114-11.114-11.114Zm0 19.231c-4.476 0-8.117-3.641-8.117-8.117 0-4.476 3.641-8.117 8.117-8.117 4.476 0 8.117 3.641 8.117 8.117 0 4.476-3.641 8.117-8.117 8.117Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M35.853 54.009H15.988V9.991H48v23.814a13.05 13.05 0 0 1 3.996 1.006V5.996H15.994a4 4 0 0 0-4 4v44.009a4 4 0 0 0 4 4h23.959a13.214 13.214 0 0 1-4.099-3.996h-.001Z"
        }
      )
    ]
  }
);
export {
  e as ExitFees
};
